module.exports = __webpack_public_path__ + "static/img/wifi_ad_icon.b2a548bd.png";